import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import TypeCard from './type-card';

class ContributeSelectType extends Component {
    static propTypes = {
        disablePledge: PropTypes.bool.isRequired,
        onSelectDonate: PropTypes.func.isRequired,
        onSelectPledge: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        performanceEstimate: PropTypes.number.isRequired,
        singularMetricName: PropTypes.string.isRequired,
        pluralMetricName: PropTypes.string.isRequired,
        pluralEventName: PropTypes.string.isRequired,
        collapsible: PropTypes.bool,
    };

    static defaultProps = {
        collapsible: false,
    };

    state = {
        expanded: null,
    };

    get formattedEstimate() {
        const { performanceEstimate } = this.props;
        return numeral(performanceEstimate).format('0,0[.]0');
    }

    setExpanded = expanded => this.setState({ expanded });

    render() {
        const {
            disablePledge,
            onSelectPledge,
            onSelectDonate,
            name,
            singularMetricName,
            pluralMetricName,
            pluralEventName,
            collapsible,
        } = this.props;

        const { expanded } = this.state;

        return (
            <>
                <hgroup className="mb-8 md:mb-12 xxxl:mb-16">
                    <p className="text-16 text-gray-40 font-medium mb-1 md:mb-2 truncate">{name}</p>
                    <h1 className="font-black text-21 md:text-24 xxxl:text-28 text-gray-70">
                        How would you like to contribute?
                    </h1>
                </hgroup>
                <div className="-mx-4 lg:-mx-8">
                    <div className="flex flex-col md:flex-row -ml-12 -mt-4">
                        <div className="pl-12 pt-4 md:w-1/2 flex flex-col">
                            {disablePledge ? (
                                <TypeCard
                                    type="pledge"
                                    title={`Per ${singularMetricName}`}
                                    description={`You can no longer pledge per ${singularMetricName} as all the ${pluralEventName} have already passed.`}
                                    onSelect={() => {}}
                                    buttonLabel={`Make a pledge per ${singularMetricName}`}
                                    expanded={!collapsible || expanded === 'pledge'}
                                    onExpand={() => this.setExpanded('pledge')}
                                    disabled
                                />
                            ) : (
                                <TypeCard
                                    type="pledge"
                                    title={`Per ${singularMetricName}`}
                                    description={`Your total contribution will be determined by the number of ${pluralMetricName} recorded during this campaign. We've
                                estimated a total of ${this.formattedEstimate} ${
                                        this.formattedEstimate === 1
                                            ? singularMetricName
                                            : pluralMetricName
                                    } for this campaign.`}
                                    onSelect={onSelectPledge}
                                    buttonLabel={`Make a pledge per ${singularMetricName}`}
                                    expanded={!collapsible || expanded === 'pledge'}
                                    onExpand={() => this.setExpanded('pledge')}
                                />
                            )}
                        </div>
                        <div className="pl-12 pt-4 md:w-1/2 flex flex-col">
                            <TypeCard
                                type="donation"
                                title="One-time donation"
                                description={`Your donation will be immediate and is not affected by the number of ${pluralMetricName} recorded during this campaign.`}
                                onSelect={onSelectDonate}
                                buttonLabel="Make a one-time donation"
                                expanded={!collapsible || expanded === 'donate'}
                                onExpand={() => this.setExpanded('donate')}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ContributeSelectType;
